import { Contact } from "@/components/views/supportingPages"
import { getSitesStaticPaths, getSiteStaticProps } from "@/utils/pageUtils";
import SipjoyAppContext from "@/src/contexts/SipjoyAppContext"


const contactPage = ({siteContext}) => {
  
  return (
    <SipjoyAppContext siteContext={siteContext}>
      <Contact />
    </SipjoyAppContext>
  )
}


export default contactPage


export async function getStaticProps({ params }) {
  return getSiteStaticProps({ params })
}

export async function getStaticPaths() {
  return getSitesStaticPaths();
}